import React, { useState, useEffect, useRef } from 'react';
import defaultClasses from '../configuratorShare.module.css';
import { useStyle } from '../../lib/util/classify';
// see all icons here: https://feathericons.com/
import {
    Save as SaveIcon,
    Loader as LoaderIcon,
    PlusCircle as AddIcon
} from 'react-feather';
import { useSaveConfiguration } from '../../talons/ProductConfigurator/useSaveConfiguration';
import classNames from '../../lib/util/classNames';
import dateToLocaleFormat from '../../lib/util/dateToLocaleFormat';
import ModalLogin from '../../components/ModalLogin';

const SaveConfiguration = props => {
    const {
        label,
        isSignedIn,
        isAddingToWishlist,
        groups,
        saveProductToWishlist
    } = useSaveConfiguration(props);

    const classes = useStyle(defaultClasses, props.classes);

    const handleSaveButtonClick = () => {
        if (isSignedIn) {
            setIsGroupListOpen(true);
        } else {
            setIsLoginOpen(true);
        }
    };

    const [isGroupListOpen, setIsGroupListOpen] = useState(false);
    const [isLoginOpen, setIsLoginOpen] = useState(false);

    const groupListRef = useRef();

    useEffect(() => {
        const handleClickOutside = e => {
            if (
                groupListRef.current &&
                !groupListRef.current.contains(e.target)
            ) {
                setIsGroupListOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const saveToNewGroup = () => {
        const suggestedGroupName = _(
            'Project created on {0}',
            dateToLocaleFormat(new Date())
        );

        const newGroupName = prompt(
            _('Enter new project name:'),
            suggestedGroupName
        );

        if (newGroupName) {
            saveProductToWishlist(newGroupName);
        }

        setIsGroupListOpen(false);
    };

    return (
        <>
            <div className={classes.root}>
                <div className={classes.saveWrapper} ref={groupListRef}>
                    <button
                        className={classes.button}
                        disabled={isAddingToWishlist}
                        onClick={handleSaveButtonClick}
                        aria-expanded={isGroupListOpen}
                        aria-haspopup={true}
                    >
                        {isAddingToWishlist ? (
                            <LoaderIcon className={classes.loader} />
                        ) : (
                            <SaveIcon className={classes.icon} />
                        )}
                        {label || _('Save')}
                    </button>
                    {isGroupListOpen && (
                        <ul className={classes.groupsList}>
                            {groups.map(group => (
                                <li
                                    key={group}
                                    className={classes.groupItem}
                                    onClick={async () => {
                                        await saveProductToWishlist(group);
                                        setIsGroupListOpen(false);
                                    }}
                                >
                                    {group}
                                </li>
                            ))}
                            <li
                                className={classNames(
                                    classes.groupItem,
                                    classes.newGroup
                                )}
                                onClick={saveToNewGroup}
                            >
                                <AddIcon width={16} />
                                {_('Create new project')}
                            </li>
                        </ul>
                    )}
                </div>
            </div>
            <ModalLogin isOpen={isLoginOpen} setIsOpen={setIsLoginOpen} />
        </>
    );
};

export default SaveConfiguration;
